import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { QrCode, Ticket } from "lucide-react";

interface NavItemsProps {
  setIsCheckBookingOpen: (open: boolean) => void;
  onLinkClick?: () => void;
  showStickyNav?: boolean;
}

export const NavItems: React.FC<NavItemsProps> = ({
  setIsCheckBookingOpen,
  onLinkClick,
  showStickyNav,
}) => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleClick = () => {
    if (onLinkClick) onLinkClick();
  };

  const navItemClass = ({ isActive }: { isActive: boolean }) => `
    font-bold text-xs uppercase tracking-[0.2em] transition-all duration-500
    ${
      isActive
        ? "text-giz-primary"
        : showStickyNav || !isHome
        ? "text-slate-600 hover:text-giz-primary"
        : "text-white hover:text-white/80"
    }
  `;

  return (
    <>
      <NavLink to="/" className={navItemClass} onClick={handleClick}>
        Beranda
      </NavLink>
      {/* <NavLink to="/about" className={navItemClass} onClick={handleClick}>
        Tentang
      </NavLink> */}
      <NavLink to="/attractions" className={navItemClass} onClick={handleClick}>
        Wahana
      </NavLink>
      <NavLink to="/news" className={navItemClass} onClick={handleClick}>
        Berita
      </NavLink>
      <NavLink
        to="/partner-register"
        className={navItemClass}
        onClick={handleClick}
      >
        Mitra
      </NavLink>

      <button
        onClick={() => {
          setIsCheckBookingOpen(true);
          handleClick();
        }}
        className={`font-bold text-xs uppercase tracking-[0.2em] transition-all duration-500 flex items-center gap-2 group ${
          showStickyNav || !isHome
            ? "text-slate-600 hover:text-giz-primary"
            : "text-white hover:text-white/80"
        }`}
      >
        <QrCode className="w-4 h-4 group-hover:rotate-12 transition-transform" />
        <span>Cek Tiket</span>
      </button>

      <NavLink
        to="/#book-section"
        className={`px-8 py-4 rounded-2xl font-black text-[11px] uppercase tracking-[0.25em] transition-all active:scale-95 shadow-2xl ${
          showStickyNav || !isHome
            ? "bg-slate-900 text-white hover:bg-giz-primary"
            : "bg-white text-slate-900 hover:bg-indigo-50"
        }`}
        onClick={handleClick}
      >
        Booking Online
      </NavLink>
    </>
  );
};

export default NavItems;
